import { useState, useEffect } from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import Axios from '../../../config/axios';
import { message } from 'antd';
import Globals from '../../../config/globals';
import evitePng from '../../../img/evite_thumbnail.png';
import d2pLogo from '../../../img/D2P-logo.png';
import htmlPng from '../../../img/Thumb_HTML.PNG';
import jpgPng from '../../../img/Thumb_JPG.PNG';
import pdfPng from '../../../img/Thumb_PDF.PNG';
import txtPng from '../../../img/Thumb_TXT.PNG';
import thumbVideo from '../../../img/Thumb_Video.PNG';
import placeholderImg from '../../../img/sample_placeholder.png';
import { toast, confirm } from '@rickylandino/react-messages';

export function ETicketSlider({ showPane, showCode, hidePane }) {

    const [showPaneState, setShowPaneState] = useState(showPane);

    useEffect(() => {
        setShowPaneState(showPane);
    }, [showPane])


    // Loading state for each download button
    const [loadingBtn, setLoadingBtn] = useState({});

    const setLoading = (label, value) => {
        setLoadingBtn(prev => ({ ...prev, [label]: value }));
    };

    const downloadHtmlInvite = async () => {
        setLoading('HTML Invite', true);
        try {
            const response = await Axios.get(`/api/DownloadEviteHtml`, {
                params: {
                    id: Globals.userInfo.companyId,
                    showcode: showCode || Globals.defaultShowCode
                }
            }, { responseType: 'blob' });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'd2p_exhibitor_invite.html';
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading('HTML Invite', false);
        }
    }

    const downloadTxtInvite = async () => {
        setLoading('TXT Invite', true);
        try {
            const response = await Axios.get(`/api/DownloadEviteTxt`, {
                params: {
                    id: Globals.userInfo.companyId,
                    showcode: showCode || Globals.defaultShowCode
                }
            }, { responseType: 'blob' });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'd2p_exhibitor_invite.txt';
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading('TXT Invite', false);
        }
    }

    const downloadPdfInvite = async () => {
        setLoading('PDF Invite', true);
        try {
            const response = await Axios.get(`/api/DownloadEvitePdf?showcode=${encodeURIComponent(showCode || Globals.defaultShowCode)}&id=${Globals.userInfo.companyId}`, {
                responseType: 'blob', // Important for binary data
            });

            // Create a blob URL for the PDF
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

            // Create a temporary anchor to trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'd2p_exhibitor_invite.pdf');
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        } finally {
            setLoading('PDF Invite', false);
        }
    }

    async function downloadEviteJpg() {
        setLoading('JPG Invite', true);
        try {
            const response = await Axios.get(`/api/DownloadEviteJpg?showcode=${encodeURIComponent(showCode || Globals.defaultShowCode)}&id=${Globals.userInfo.companyId}`, {
                responseType: 'blob', // Important for binary data
            });

            // Create a blob URL for the JPG
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/jpeg' }));

            // Create a temporary anchor to trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'd2p_exhibitor_invite.jpg');
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        } finally {
            setLoading('JPG Invite', false);
        }
    }

    // Download D2P Logo handler
    const downloadD2PLogo = () => {
        setLoading('D2P Logo', true);
        try {
            // Create a link and trigger download
            const link = document.createElement('a');
            link.href = d2pLogo;
            link.setAttribute('download', 'D2P-logo.png');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } finally {
            setLoading('D2P Logo', false);
        }
    };

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText('https://www.youtube.com/watch?v=F0itEpw1qU4');

            toast.success("Video link successfully copied to your clipboard.");
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    }

    const inviteTypes = [
        { thumbnail: htmlPng, label: 'HTML Invite', preview: 'HTML Preview', downloadAction: downloadHtmlInvite },
        { thumbnail: jpgPng, label: 'JPG Invite', preview: 'JPG Preview', downloadAction: downloadEviteJpg },
        { thumbnail: pdfPng, label: 'PDF Invite', preview: 'PDF Preview', downloadAction: downloadPdfInvite },
        { thumbnail: evitePng, label: 'D2P Logo', preview: 'Logo Preview', downloadAction: downloadD2PLogo },
        { thumbnail: thumbVideo, label: 'D2P Video Link', preview: 'Logo Preview', copyLinkAction: copyToClipboard }
    ];

    return (
        <SlidingPane
            className='some-custom-class'
            overlayClassName='showCard'
            isOpen={showPaneState}
            title='Exhibitor Invite Program'
            onRequestClose={hidePane}
            closeIcon={<i className="fas fa-chevron-right float-left"></i>}
            width="60%"
        >
            <div className="slide-pane-body scrollableDiv">
                {/* Header Section */}
                <div className="mb-4" style={{ fontSize: '15px' }}>
                    <div style={{ marginBottom: 10 }}>
                        <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                            The Design-2-Part "Exhibitor Invite Program" provides ready-to-use marketing assets to help you invite customers and prospects to visit your booth at the show. These materials are designed to save you time while maximizing awareness and attendance.
                        </p>

                        <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                            All assets are easy to use, easy to share, and optimized for email, web, and social channels.
                        </p>

                        <p style={{ marginBottom: '0.5rem', lineHeight: 1.3 }}>
                            How Can I Use the Exhibitor Invite Program?
                        </p>

                        <ul style={{ marginTop: 0, paddingLeft: '1.2rem', listStyleType: 'none' }}>
                            <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                <strong>Step 1:</strong> Choose the assets that best fit your marketing needs
                            </li>
                            <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                <strong>Step 2:</strong> Download or copy the files directly from this page
                            </li>
                            <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                <strong>Step 3:</strong> Share with your customers and prospects before the show
                            </li>
                            <li style={{ marginBottom: 0, lineHeight: 1.3 }}>
                                <strong>Step 4:</strong> Drive quality traffic to your booth
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Main Content Section */}
                <div className="d-flex flex-row flex-wrap" style={{ gap: 32 }}>
                    {/* Left: Invite Image */}
                    <div style={{ flex: '1 1 320px', minWidth: 280, maxWidth: 400, display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <img
                            src={placeholderImg}
                            alt="Event Invite"
                            style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px #0001' }}
                        />
                    </div>

                    {/* Right: Download Cards */}
                    <div style={{ flex: '2 1 400px', minWidth: 320, display: 'flex', flexDirection: 'column', gap: 24 }}>
                        {/* Stack the three cards vertically */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                            {/* HTML Invite */}
                            <div className="card bg-light text-center border-0 shadow-sm d-flex flex-row" style={{ marginBottom: '0.25rem' }}>
                                <div className="p-2"> {/* reduced from p-3 */}
                                    <div className="fw-bold mb-1" style={{ fontSize: 'small' }}>HTML Invite</div>
                                    <img
                                        src={htmlPng}
                                        alt="HTML Invite"
                                        className="mb-2"
                                        style={{ width: 48, height: 48, objectFit: 'contain' }}
                                    />
                                    <div>
                                        <button
                                            className="btn btn-warning btn-sm"
                                            onClick={downloadHtmlInvite}
                                            disabled={!!loadingBtn['HTML Invite']}
                                        >
                                            {loadingBtn['HTML Invite'] ? (
                                                <span>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Downloading...
                                                </span>
                                            ) : (
                                                'Download'
                                            )}
                                        </button>
                                    </div>

                                    <div className="fw-bold mb-1" style={{ fontSize: 'small' }}>TXT Invite</div>
                                    <img
                                        src={txtPng}
                                        alt="TXT Invite"
                                        className="mb-2"
                                        style={{ width: 48, height: 48, objectFit: 'contain' }}
                                    />
                                    <div>
                                        <button
                                            className="btn btn-warning btn-sm"
                                            onClick={downloadTxtInvite}
                                            disabled={!!loadingBtn['HTML Invite']}
                                        >
                                            {loadingBtn['TXT Invite'] ? (
                                                <span>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Downloading...
                                                </span>
                                            ) : (
                                                'Download'
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="align-self-center p-2"> {/* reduced from p-3 */}
                                    <div style={{ fontSize: '15px', textAlign: 'left' }}>
                                        <div style={{ marginBottom: 5 }}> {/* reduced from 10 */}
                                            <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                                A fully coded email invitation designed for email platforms that support HTML templates.
                                            </p>

                                            <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                                <strong>How to use:</strong>
                                            </p>

                                            <ul style={{ marginTop: 0, paddingLeft: '1.2rem', textAlign: 'left' }}>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Download the HTML file
                                                </li>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Upload it into your email marketing platform
                                                </li>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Add your company details and booth number
                                                </li>
                                                <li style={{ marginBottom: 0, lineHeight: 1.3 }}>
                                                    Send to your customer and prospect lists
                                                </li>
                                            </ul>

                                            <p style={{ marginTop: '0.5rem', lineHeight: 1.3 }}>
                                                <strong>Recommended for:</strong> Mailchimp, HubSpot, Constant Contact, Marketo, and similar platforms
                                            </p>
                                            <p style={{ marginTop: '0.5rem', lineHeight: 1.3 }}>
                                                The TXT file is a recommended template to use as an email to send to individual recipients via an Email Client like Outlook.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* JPG Invite */}
                            <div className="card bg-light text-center border-0 shadow-sm d-flex flex-row" style={{ marginBottom: '0.25rem' }}>
                                <div className="p-2"> {/* reduced padding */}
                                    <div className="fw-bold mb-1" style={{ fontSize: 'small' }}>JPG Invite</div>
                                    <img
                                        src={jpgPng}
                                        alt="JPG Invite"
                                        className="mb-2"
                                        style={{ width: 48, height: 48, objectFit: 'contain' }}
                                    />
                                    <div>
                                        <button
                                            className="btn btn-warning btn-sm"
                                            onClick={downloadEviteJpg}
                                            disabled={!!loadingBtn['JPG Invite']}
                                        >
                                            {loadingBtn['JPG Invite'] ? (
                                                <span>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Downloading...
                                                </span>
                                            ) : (
                                                'Download'
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="align-self-center p-2"> {/* reduced padding */}
                                    <div style={{ fontSize: '15px', textAlign: 'left' }}>
                                        <div style={{ marginBottom: 5 }}> {/* reduced spacing */}
                                            <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                                A static image version of the exhibitor invite that can be inserted into most email platforms.
                                            </p>

                                            <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                                <strong>How to use:</strong>
                                            </p>

                                            <ul style={{ marginTop: 0, paddingLeft: '1.2rem', textAlign: 'left' }}>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Download the JPG file
                                                </li>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Insert the image into your email campaign
                                                </li>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Add a short message above or below the image
                                                </li>
                                                <li style={{ marginBottom: 0, lineHeight: 1.3 }}>
                                                    Link the image to the show registration page
                                                </li>
                                            </ul>

                                            <p style={{ marginTop: '0.5rem', lineHeight: 1.3 }}>
                                                <strong>Best for:</strong> Platforms that do not support HTML templates
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* PDF Invite */}
                            <div className="card bg-light text-center border-0 shadow-sm d-flex flex-row" style={{ marginBottom: '0.25rem' }}>
                                <div className="p-2"> {/* reduced padding */}
                                    <div className="fw-bold mb-1" style={{ fontSize: 'small' }}>PDF Invite</div>
                                    <img
                                        src={pdfPng}
                                        alt="PDF Invite"
                                        className="mb-2"
                                        style={{ width: 48, height: 48, objectFit: 'contain' }}
                                    />
                                    <div>
                                        <button
                                            className="btn btn-warning btn-sm"
                                            onClick={downloadPdfInvite}
                                            disabled={!!loadingBtn['PDF Invite']}
                                        >
                                            {loadingBtn['PDF Invite'] ? (
                                                <span>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Downloading...
                                                </span>
                                            ) : (
                                                'Download'
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="align-self-center p-2"> {/* reduced padding */}
                                    <div style={{ fontSize: '15px', textAlign: 'left' }}>
                                        <div style={{ marginBottom: 5 }}> {/* reduced spacing */}
                                            <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                                A printable and downloadable exhibitor invitation in PDF format.
                                            </p>

                                            <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                                <strong>How to use:</strong>
                                            </p>

                                            <ul style={{ marginTop: 0, paddingLeft: '1.2rem', textAlign: 'left' }}>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Download the PDF file
                                                </li>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Attach to one-to-one emails or email campaigns
                                                </li>
                                                <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                                    Share as a downloadable invite with customers
                                                </li>
                                                <li style={{ marginBottom: 0, lineHeight: 1.3 }}>
                                                    Use for printing or offline promotion if needed
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*<div className="card mb-2 bg-light text-center border-0 shadow-sm d-flex flex-row">*/}
                {/*    */}{/* D2P Logo */}
                {/*    <div className="p-3 d-flex flex-column align-items-center" style={{ minWidth: 200, maxWidth: 220 }}>*/}
                {/*        <div className="fw-bold mb-2" style={{ fontSize: 'small' }}>D2P Logo</div>*/}
                {/*        <img src={d2pLogo} alt="D2P Logo" style={{ width: 100, height: 100, objectFit: 'contain', marginBottom: 8 }} />*/}
                {/*        <button*/}
                {/*            className="btn btn-warning btn-sm w-100"*/}
                {/*            onClick={downloadD2PLogo}*/}
                {/*            disabled={!!loadingBtn['D2P Logo']}*/}
                {/*        >*/}
                {/*            {loadingBtn['D2P Logo'] ? (*/}
                {/*                <span>*/}
                {/*                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>*/}
                {/*                    Downloading...*/}
                {/*                </span>*/}
                {/*            ) : (*/}
                {/*                'Download'*/}
                {/*            )}*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*    */}{/* D2P Video Link */}
                {/*    <div className=" p-3 d-flex flex-column align-items-center" style={{ minWidth: 200, maxWidth: 220 }}>*/}
                {/*        <div className="fw-bold mb-2" style={{ fontSize: 'small' }}>D2P Video Link</div>*/}
                {/*        <img src={thumbVideo} alt="D2P Video" style={{ width: 100, height: 100, objectFit: 'contain', marginBottom: 8 }} />*/}
                {/*        <button*/}
                {/*            className="btn btn-warning btn-sm w-100"*/}
                {/*            onClick={copyToClipboard}*/}
                {/*        >*/}
                {/*            Copy Video Link*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*    <div className="align-self-center p-3">*/}
                {/*        Some Text Content Describing what this stuff is. Some Text Content Describing what this stuff is. Some Text Content Describing what this stuff is. Some Text Content Describing what this stuff is. Some Text Content Describing what this stuff is. Some Text Content Describing what this stuff is.*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            <div className="modal-footer">
                <div className="form-group col-12 padding-25-10">
                    <button className="btn btn-primary btn-lg margin-left-15" onClick={hidePane}>Close</button>
                </div>
            </div>
        </SlidingPane>
    );
}